import * as React from 'react'
interface InputPasswordProps extends React.InputHTMLAttributes<HTMLInputElement> {}
export const InputPassword = ({className, ...props}: InputPasswordProps) => {
  const [isVisiblePassword, setIsVisiblePassword] = React.useState<boolean>(false)

  return (
    <div className='position-relative w-100'>
      <input
        type={isVisiblePassword ? 'text' : 'password'}
        autoComplete='off'
        {...props}
        className={className}
      />
      <span
        className='position-absolute cursor-pointer fw-bold fs-8 text-primary text-uppercase bottom-100 end-0 d-inline-block'
        onClick={() => setIsVisiblePassword(!isVisiblePassword)}
      >
        {isVisiblePassword ? 'Ocultar' : 'Mostrar'}
      </span>
    </div>
  )
}
